import { MobileApp } from "../../../entity/MobileApp";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { MobileAppDto } from "../../dto/MobileApp.Dto";
import { MobileAppMapper } from "../../mapper/MobileAppMapper";

class WSMobileApp {

    private static instance: WSMobileApp;

    private constructor() { }

    public static getInstance(): WSMobileApp {
        if (!WSMobileApp.instance) {
            WSMobileApp.instance = new WSMobileApp();
        }
        return WSMobileApp.instance;
    }

    public async getLatestVersion(): Promise<MobileApp | null> {
        try {
            const url = `${ROUTES.MOBILE_APP}${ROUTES.GET_LATEST_VERSION}`;

            const response = await fetchAPI<MobileAppDto>({
                url,
                method: Method.GET,
                params: {},
                isAuthenticated: true,
            });
            return response.data ? MobileAppMapper.mapToMobileAppDto(response.data) : null;
        } catch (error) {
            console.error("Get latest version failed:", error);
            throw error;
        }
    }

    public async getAllVersions(): Promise<MobileApp[] | null> {
        try {
            const url = `${ROUTES.MOBILE_APP}${ROUTES.GET_ALL_VERSIONS}`;

            const response = await fetchAPI<MobileAppDto[]>({
                url,
                method: Method.GET,
                params: {},
                isAuthenticated: true,
            });
            return response.data ? response.data.map(MobileAppMapper.mapToMobileAppDto) : null;
        } catch (error) {
            console.error("Get all versions failed:", error);
            throw error;
        }
    }

    public async deleteVersion(versionId: string): Promise<void> {
        try {
            const url = `${ROUTES.MOBILE_APP}${ROUTES.DELETE_VERSION}${versionId}`;

            await fetchAPI<void>({
                url,
                method: Method.DELETE,
                params: {},
                isAuthenticated: true,
            });
        } catch (error) {
            console.error("Delete version failed:", error);
            throw error;
        }
    }


    public async uploadVersion(mobileApp: MobileApp): Promise<MobileApp | null> {
        try {
            const url = `${ROUTES.MOBILE_APP}${ROUTES.MOBILE_UPLOAD}`

            const response = await fetchAPI<MobileAppDto>({
                url,
                method: Method.POST,
                params: mobileApp,
                isAuthenticated: true,
            });
            return response.data ? MobileAppMapper.mapToMobileAppDto(response.data) : null;
        } catch (error) {
            console.error("Upload version failed:", error);
            throw error;
        }
    }

}

export default WSMobileApp.getInstance();
